module.exports = window["Plaid"];